import { getShimmerDataURL } from '../../utils/imageUtils';

export function ItemCardSkeleton() {
  return (
    <div
      className="relative bg-white overflow-hidden"
      style={{
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.12)',
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)',
      }}
    >
      {/* Image placeholder with shimmer effect */}
      <div className="relative w-full overflow-hidden" style={{ paddingBottom: '100%' }}>
        <img
          src={getShimmerDataURL()}
          alt=""
          className="absolute inset-0 w-full h-full object-cover animate-pulse"
          style={{
            filter: 'blur(10px)',
          }}
        />
      </div>

      {/* Content placeholder */}
      <div className="p-3 space-y-2">
        {/* Title placeholder */}
        <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>

        {/* Brand placeholder */}
        <div className="h-3 bg-gray-200 rounded w-1/2 animate-pulse" style={{ animationDelay: '150ms' }}></div>

        {/* Likes placeholder */}
        <div className="flex items-center gap-2 mt-2">
          <div className="h-3.5 w-3.5 bg-gray-200 rounded-full animate-pulse" style={{ animationDelay: '300ms' }}></div>
          <div className="h-3 bg-gray-200 rounded w-12 animate-pulse" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
}